import { MatSelectModule } from '@angular/material/select';
import { HoraMeridianaPipe } from './../../pipes/hora-meridiana.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MenuComponent } from './menu/menu.component';
import { ToastInformativoComponent } from './toast-informativo/toast-informativo.component';
import { BarraPaginacionComponent } from './barra-paginacion/barra-paginacion.component';
import { GrupoBotonesComponent } from './grupo-botones/grupo-botones.component';
import { BotonesCambiosComponent } from './botones-cambios/botones-cambios.component';
import { TablaGeneralComponent } from './tabla-general/tabla-general.component';
import { MatTableModule } from '@angular/material/table';
import { ComponentesCompartidosRoutingModule } from './componentes-compartidos-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { DialogoPagosComponent } from './dialogo-pagos/dialogo-pagos.component';
import { BuscarComponent } from './buscar/buscar.component';
import { CalendarioMesComponent } from './calendario-mes/calendario-mes.component';
import { FiltroFechaComponent } from './filtro-fecha/filtro-fecha.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SelectIndicativoComponent } from './select-indicativo/select-indicativo.component';
import { GrupoFamiliarComponent } from './grupo-familiar/grupo-familiar.component';

@NgModule({
  declarations: [
    MenuComponent,
    ToastInformativoComponent,
    BarraPaginacionComponent,
    GrupoBotonesComponent,
    BotonesCambiosComponent,
    TablaGeneralComponent,
    HeaderComponent,
    DialogoPagosComponent,
    HoraMeridianaPipe,
    BuscarComponent,
    CalendarioMesComponent,
    FiltroFechaComponent,
    SelectIndicativoComponent,
    GrupoFamiliarComponent
  ],
  exports: [
    MenuComponent,
    ToastInformativoComponent,
    GrupoBotonesComponent,
    BotonesCambiosComponent,
    TablaGeneralComponent,
    HeaderComponent,
    HoraMeridianaPipe,
    BuscarComponent,
    CalendarioMesComponent,
    SelectIndicativoComponent,
    GrupoFamiliarComponent
  ],
  imports: [
    MatSelectModule,
    MatProgressSpinnerModule,
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatMenuModule,
    ComponentesCompartidosRoutingModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    ComponentesCompartidosRoutingModule,
    MatCheckboxModule
  ]
})
export class ComponentesCompartidosModule { }
